import { render, staticRenderFns } from "./order-add.vue?vue&type=template&id=0f9dfc3e&%23default=true"
import script from "./order-add.vue?vue&type=script&lang=js"
export * from "./order-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports